import React from "react";

function CommonFormActions({
  className = "modal-footer-custom",
  cancelLabel = "Cancel",
  submitLabel = "Submit",
  onCancel,
  onSubmit,
  submitType = "submit",
  cancelType = "button",
  cancelClassName = "btn-cancel",
  submitClassName = "btn-submit",
  cancelDisabled = false,
  submitDisabled = false,
}) {
  return (
    <div className={className}>
      <button
        type={cancelType}
        className={cancelClassName}
        onClick={onCancel}
        disabled={cancelDisabled}
      >
        {cancelLabel}
      </button>
      <button
        type={submitType}
        className={submitClassName}
        onClick={onSubmit}
        disabled={submitDisabled}
      >
        {submitLabel}
      </button>
    </div>
  );
}

export default CommonFormActions;
